import React from 'react';
import { useInView } from '../hooks/useInView';
import { useLanguage } from '../context/LanguageContext';

const ParallaxSection = ({ sloganIndex, imageUrl }) => {
  const { t } = useLanguage();
  const [ref, isInView] = useInView({ threshold: 0.3 });

  const quote = t.slogans[sloganIndex] || t.slogans[0];

  return (
    <section
      ref={ref}
      className="relative py-32 lg:py-48 overflow-hidden"
    >
      {/* Background with Parallax Effect */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-fixed"
        style={{
          backgroundImage: `url('${imageUrl}')`,
        }}
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/75" />

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        {/* Decorative Elements */}
        <div className="flex items-center justify-center mb-8">
          <div className="w-16 h-px bg-[#0067ff]" />
          <div className="w-3 h-3 border border-[#0067ff] rotate-45 mx-4" />
          <div className="w-16 h-px bg-[#0067ff]" />
        </div>

        {/* Quote */}
        <blockquote
          className={`font-serif text-2xl md:text-4xl lg:text-5xl text-white font-light italic leading-tight transition-all duration-1000 ${
            isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          "{quote}"
        </blockquote>

        {/* Bottom Decorative Elements */}
        <div className="flex items-center justify-center mt-8">
          <div className="w-16 h-px bg-[#0067ff]" />
          <div className="w-3 h-3 border border-[#0067ff] rotate-45 mx-4" />
          <div className="w-16 h-px bg-[#0067ff]" />
        </div>
      </div>
    </section>
  );
};

export default ParallaxSection;
